import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazy } from "react";

// Lazily loaded — the library gallery + lightbox isn't needed on the default
// /chat landing, so it ships as its own chunk.
const LibraryPage = lazy(() =>
  import("../components/LibraryPage").then((m) => ({ default: m.LibraryPage })),
);

/**
 * Library route — composed into the app shell layout in `app/router.tsx`. The
 * page renders its title + filter controls into the shell topbar (TopbarSlot
 * portals), so the gallery mounts directly under the shared top row.
 */
export function createLibraryRoute<TParent extends AnyRoute>(parent: TParent) {
  return createRoute({
    getParentRoute: () => parent,
    path: "/library",
    component: LibraryPage,
  });
}
